module.exports = __webpack_public_path__ + "img/ksj008.prt.4ded9de8.jpg";